import type { CapsuleEntity } from 'new/stores/capsules/capsule.slice';

import { capsuleFromDto, formatTableRegistered } from 'new/modules/settings/capsules/domain';
import type { CapsuleTableRow } from 'new/modules/settings/capsules/viewModels/capsulesTableViewModel';

export function mapCapsuleToTableRow(capsule: CapsuleEntity): CapsuleTableRow {
  const capsuleSummary = capsuleFromDto(capsule);

  return {
    id: capsuleSummary.id,
    name: capsuleSummary.name,
    uid: capsuleSummary.uid ?? null,
    status: capsuleSummary.lifecycle,
    registeredAt: formatTableRegistered(capsuleSummary.registeredIso),
  };
}
